import React from 'react';
import PropTypes from 'prop-types';
import { TextColoredWrap, textColors } from './styles';

const TextColored = ({ children, color, ...restProps }) => (
  <TextColoredWrap color={color} {...restProps}>
    {children}
  </TextColoredWrap>
);

TextColored.propTypes = {
  children: PropTypes.oneOfType([PropTypes.elementType, PropTypes.shape()]).isRequired,
  color: PropTypes.oneOf(Object.keys(textColors)),
};

TextColored.defaultProps = {
  color: textColors.default,
};

export default TextColored;
export { textColors };